export default function Pagination({ offset, count, limit, total, onChange, busy = false }: {
  offset: number; count: number; limit: number; total?: number; onChange: (offset: number) => void; busy?: boolean;
}) {
  const label = count ? `${offset + 1}–${offset + count}${total == null ? "" : ` из ${total}`}` : "Нет записей на этой странице";
  return <nav className="pagination" aria-label="Страницы списка">
    <span aria-live="polite">{label}</span>
    <button type="button" disabled={busy || offset === 0} onClick={() => onChange(0)}>В начало</button>
    <button type="button" disabled={busy || offset === 0} onClick={() => onChange(Math.max(0, offset - limit))}>Назад</button>
    <button type="button" disabled={busy || (total == null ? count < limit : offset + count >= total)} onClick={() => onChange(offset + limit)}>Далее</button>
  </nav>;
}
